'use client'

import { useCompany } from '@/shared/hooks/useCompanies'
import DetailBlock from '@/shared/v2/shared/components/Detail/components/DetailBlock'
import UpdateSettingsProfileCompanyDrawer from '../components/UpdateSettingsProfileCompanyDrawer'
import UpdateSettingsAddressCompany from '../components/UpdateSettingsAddressCompanyDrawer'
import { useTranslations } from 'next-intl'

const SettingsProfilePage = () => {
    const t = useTranslations('settings')
    const company = useCompany()

    return (
        <div className="grid grid-cols-1 gap-5">
            <DetailBlock
                title={t('company.legalsInformationsTitle')}
                columns={2}
                action={<UpdateSettingsProfileCompanyDrawer company={company.data} />}
                isLoading={company.isLoading}
                fields={[
                    {
                        label: t('company.update.inputs.name.label'),
                        value: company.data?.name
                    },
                    {
                        label: t('company.update.inputs.country.label'),
                        value: company.data?.identifier.country
                    },
                    {
                        label: t('company.update.inputs.identifierType.label'),
                        value: company.data?.identifier.type
                    },
                    {
                        label: t('company.update.inputs.identifierValue.label'),
                        value: company.data?.identifier.value
                    }
                ]}
            />
            <DetailBlock
                title={t('company.addressTitle')}
                columns={2}
                action={<UpdateSettingsAddressCompany company={company.data} />}
                isLoading={company.isLoading}
                fields={[
                    {
                        label: t('company.update.inputs.first.label'),
                        value: company.data?.address?.first
                    },
                    {
                        label: t('company.update.inputs.city.label'),
                        value: company.data?.address?.city
                    },
                    {
                        label: t('company.update.inputs.postal.label'),
                        value: company.data?.address?.postal
                    },
                    {
                        label: t('company.update.inputs.country.label'),
                        value: company.data?.address?.country
                    }
                ]}
            />
        </div>
    )
}

export default SettingsProfilePage
